import React, { useEffect, useState } from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Button,
  Card,
  Box,
  MenuItem,
  Select,
  Typography,
  Divider,
  useTheme,
  CardContent,
  Paper
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import ProfileUpdateInfo from "../../components/ProfileUpdateInfo/ProfileUpdateInfo";
import Notify from "../../components/Notify/Notify";
import Loading from "../../components/Loading";
import { createPreference, getPreference, enabledDisabledLogin, fetCandidateEvent, resetUserLoginUser, saveEvent, deleteCandidateEvent } from "../../store/action";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import axios from "axios";
const useStyles = makeStyles((theme) => ({
  pageTitle: {
    marginBottom: theme.spacing(1),
    fontWeight: 700,
  },
  mainContainer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(4),
    borderRadius: 8,
    boxShadow: "0px 6px 18px rgba(0,0,0,0.08)",
    // marginTop: theme.spacing(2),
    transition: "all 0.3s ease",
    "&:hover": {
      boxShadow: "0px 10px 26px rgba(0,0,0,0.12)",
    },
  },
  sectionHeading: {
    color: theme.palette.text.primary,
    fontWeight: 600,
    fontSize: "1.15rem",
    marginBottom: theme.spacing(1),
  },
  sectionSubtext: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2.5),
    fontSize: "0.9rem",
  },
  cardBox: {
    padding: theme.spacing(2),
    borderRadius: 12,
    boxShadow: "0px 2px 10px rgba(0,0,0,0.06)",
  },
  divider: {
    margin: theme.spacing(3, 0),
  },
  dayListBox: {
    maxWidth: "170px"
  },
  calendarContainer: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
  },
  availabilityPanel: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(1),
    backgroundColor: theme.palette.background.main,
  },

  availabilityButton: {
    margin: theme.spacing(0.5),
    minWidth: '120px',
  },
}));



const Preferences = () => {
  const user_id = JSON.parse(window.localStorage.getItem('signeeInfo')).id;
  const theme = useTheme();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { getPreferenceList, loading, createPreferenceSuccess, savedEvent, saveEventError, deleteLoading, deleteEventError, deleteEvent, event } = useSelector(
    (state) => state.preference
  );
  const availabilityOptions = [
    { key: "longDay", label: "Longday", color: theme.palette.text.longDay },
    { key: "night", label: "Night", color: theme.palette.text.night },
    { key: "earLy", label: "Early", color: theme.palette.text.earLy },
    { key: "late", label: "Late", color: theme.palette.text.late },
    { key: "twiLight", label: "Twilight", color: theme.palette.text.twiLight },
    { key: "notAvailable", label: "Not Available", color: theme.palette.text.notAvailable },
  ];
  const [events, setEvents] = useState([]);
  const [eventDate, setDate] = useState(null);
  const [status, setStatus] = useState(null);
  const [info, setInfo] = useState("");

  const [preferencetMsg, setPreferencetMsg] = useState(false);
  const [data, setData] = useState({
    monday_day: 0,
    monday_night: 0,
    tuesday_day: 0,
    tuesday_night: 0,
    wednesday_day: 0,
    wednesday_night: 0,
    thursday_day: 0,
    thursday_night: 0,
    friday_day: 0,
    friday_night: 0,
    saturday_day: 0,
    saturday_night: 0,
    sunday_day: 0,
    sunday_night: 0,
    is_travel: 0,
    no_of_shift: 0,
  });

  const handleChangeCheckbox = (event) => {
    const { checked, name } = event.target;
    setData((prev) => ({ ...prev, [name]: checked ? 1 : 0 }));
  };

  const handleChange = (event) => {
    setData((prev) => ({
      ...prev,
      [event.target.name]: parseInt(event.target.value),
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(createPreference(data));
    setPreferencetMsg(true);
  };

  useEffect(() => {
    if (getPreferenceList?.data) {
      setData(getPreferenceList.data);
    }
  }, [getPreferenceList]);

  useEffect(() => {
    dispatch(getPreference());
  }, [dispatch]);

  const handleDateClick = (info) => {
    const date = new Date(info?.date);
    const formattedDate = date.toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    setDate(formattedDate);
  };
  const handleAddEvent = (name) => {
    setStatus(name);
  }
  const eventData = {
    "user_id": user_id,
  };
  useEffect(() => {
    dispatch(fetCandidateEvent(eventData));
  }, [dispatch, user_id, savedEvent]);

  const toTitleCase = (text) => {
    if (!text) return "";
    return text
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };
  useEffect(() => {
    if (event && event.length > 0) {
      const formatted = event?.map((event) => ({
        id: event?.id,
        title: toTitleCase(event?.preferense),
        user_id: event?.user_id,
        date: event?.event_date,
        display: 'background',
        color: "black",
        backgroundColor: theme.palette.text[event?.preferense],
      }));
      setEvents(formatted);
    } else {
      setEvents([]);
    }
  }, [event])

  const handleSave = async () => {
    try {
      const date = eventDate != null ? new Date(eventDate) : null;
      const formattedDate = date ? date.toLocaleDateString("en-CA") : null;
      const isEditing = info && info.id;
      const data = {
        ...(isEditing && { id: info.id }),
        user_id: user_id,
        event_date: formattedDate,
        preferense: status,
      };

      const res = await dispatch(saveEvent(data));
      if (res?.data) {
        await dispatch(fetCandidateEvent(res.data));
      }
      setStatus(null);
      setDate(null);

    } catch (error) {
      console.log(error, "error");
    }
  }


  const handleEventClick = async (info) => {
    const event = info.event;
    if (event && event.id) {
      setInfo({ id: event.id });
    }
  }

  const [deleted, setDeleted] = useState(false);
  const handleDelete = async () => {
    const date = eventDate != null ? new Date(eventDate) : null;
    const formattedDate = date ? date.toLocaleDateString("en-CA") : null;
    try {
      const data = {
        user_id: user_id,
        event_date: formattedDate,
      };
      dispatch(deleteCandidateEvent(data))
        .then(async (res) => {
          await dispatch(fetCandidateEvent(eventData));
          setDate(null);
        })
        .catch((error) => {
          console.error("Delete event failed:", error);
          dispatch(deleteEventError(error.response?.data?.message || "Failed to delete event."));
        });
    } catch (error) {
      console.log(error, "error");
      dispatch(deleteEventError(error.message));

    }
  }
  return (
    <>
      {loading && <Loading open={loading} />}

      {preferencetMsg && createPreferenceSuccess?.message && (
        <Notify data={createPreferenceSuccess?.message} status="success" />
      )}
      {savedEvent?.message && (
        <Notify data={savedEvent?.message} status="success" />
      )}
      {saveEventError?.message && (
        <Notify data={saveEventError?.message} status="error" />
      )}

      {deleteEventError?.message && (
        <Notify data={deleteEventError?.message} status="error" />
      )}
      {deleteEvent?.message && (
        <Notify data={deleteEvent?.message} status="success" />
      )}
      <ProfileUpdateInfo />

      <Typography variant="h5" className={classes.pageTitle}>Preferences</Typography>

      <div className={classes.mainContainer}>
        <form onSubmit={handleSubmit}>
          {/* Work Day Preference */}
          <Typography className={classes.sectionHeading}>When do you prefer to work?</Typography>
          <Typography className={classes.sectionSubtext}>
            Please provide your general working patterns/preferences. Once you
            are compliant you can log onto Pluto at any time to see and book
            available shifts.
          </Typography>

          <Grid container spacing={3}>
            {[
              "monday",
              "tuesday",
              "wednesday",
              "thursday",
              "friday",
              "saturday",
              "sunday",
            ].map((day) => (
              <Grid item xs={12} sm={2} key={day} className={classes.dayListBox}>
                <Card className={classes.cardBox}>
                  <FormControl component="fieldset">
                    <Typography variant="subtitle1" gutterBottom>
                      {day.charAt(0).toUpperCase() + day.slice(1)}
                    </Typography>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={handleChangeCheckbox}
                          checked={data?.[`${day}_day`] === 1}
                          name={`${day}_day`}
                          color="primary"
                        />
                      }
                      label="Day"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={handleChangeCheckbox}
                          checked={data?.[`${day}_night`] === 1}
                          name={`${day}_night`}
                          color="primary"
                        />
                      }
                      label="Night"
                    />
                  </FormControl>
                </Card>
              </Grid>
            ))}
          </Grid>

          <Divider className={classes.divider} />
          <Grid container spacing={3} className={classes.calendarContainer}>
            {/* Calendar Section */}
            <Grid item xs={12} md={8}>
              <Card>
                <CardContent style={{ background: theme.palette.background.main }}>
                  <Typography
                    variant="h5"
                    align="center"
                    gutterBottom
                    color="primary"
                  >
                    Availability Calendar
                  </Typography>
                  <Box style={{ height: '500px' }}>
                    <FullCalendar
                      plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                      initialView="dayGridMonth"
                      events={events}
                      selectable={true}
                      dateClick={handleDateClick}
                      eventClick={(info) => handleEventClick(info)}
                      headerToolbar={{
                        // left: "prev,next today",
                        // center: "title",
                        // right: "dayGridMonth,timeGridWeek,timeGridDay",
                      }}
                      height="auto"
                    />
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            {/* Availability Settings Section */}
            <Grid item xs={12} md={4}>
              <Paper className={classes.availabilityPanel} elevation={3}>
                <Typography
                  variant="h6"
                  align="center"
                  gutterBottom
                  color="primary"
                  style={{ fontSize: "20px", fontWeight: "bold" }}
                >
                  Set Availability for:
                </Typography>

                <Typography
                  variant="subtitle1"
                  align="center"
                  gutterBottom
                  style={{ marginBottom: '20px', fontWeight: 'bold', fontSize: '23px' }}
                >
                  {eventDate}
                </Typography>

                {/* Availability Buttons */}
                <Box className={classes.buttonGroup}>
                  <Box>
                    {availabilityOptions.reduce((rows, option, index) => {
                      if (index % 2 === 0) rows.push(availabilityOptions.slice(index, index + 2));
                      return rows;
                    }, []).map((row, rowIndex) => (
                      <Box key={rowIndex} className={classes.buttonRow}>
                        {row.map((item) => (
                          <Button
                            key={item.key}
                            variant="outlined"
                            style={{ color: item.color, fontSize: "18px", fontWeight: "600" }}
                            className={classes.availabilityButton}
                            fullWidth
                            onClick={() => handleAddEvent(item.key)}
                          >
                            {item.label}
                          </Button>
                        ))}
                      </Box>
                    ))}
                  </Box>

                  {/* First Row */}
                  {/* <Box className={classes.buttonRow}>
                        <Button
                          onClick={() => handleAddEvent("longDay")}
                          variant="outlined"
                          style={{ color: theme.palette.text.longDay }}
                          className={classes.availabilityButton}
                          fullWidth
                        >
                          Longday
                        </Button>
                        <Button
                          variant="outlined"
                          onClick={() => handleAddEvent("night")}
                          style={{ color: theme.palette.text.night }}
                          className={classes.availabilityButton}
                          fullWidth
                        >
                          Night
                        </Button>
                      </Box> */}

                  {/* Second Row */}
                  {/* <Box className={classes.buttonRow}>
                        <Button
                          variant="outlined"
                          style={{ color: theme.palette.text.earLy }}
                          className={classes.availabilityButton}
                          fullWidth
                          onClick={() => handleAddEvent("earLy")}
                        >
                          Early
                        </Button>
                        <Button
                          variant="outlined"
                          style={{ color: theme.palette.text.late }}
                          className={classes.availabilityButton}
                          fullWidth
                          onClick={() => handleAddEvent("late")}
                        >
                          Late
                        </Button>
                      </Box> */}

                  {/* Third Row */}
                  {/* <Box className={classes.buttonRow}>
                        <Button
                          variant="outlined"
                          style={{ color: theme.palette.text.twiLight }}
                          className={classes.availabilityButton}
                          fullWidth
                          onClick={() => handleAddEvent("twiLight")}

                        >
                          Twilight
                        </Button>
                        <Button
                          variant="outlined"
                          style={{ color: theme.palette.text.notAvailable }}
                          className={classes.availabilityButton}
                          fullWidth
                          onClick={() => handleAddEvent("notAvailable")}
                        >
                          Not Available
                        </Button>
                      </Box> */}
                </Box>

                {/* Action Buttons */}
                <Box style={{ marginTop: '30px', display: 'flex', gap: '10px' }}>
                  <Button
                    variant="contained"
                    color={theme.palette.thead}
                    fullWidth
                    onClick={() => handleSave()}
                  >
                    Save Availability
                  </Button>
                  <Button
                    variant="contained"
                    color={theme.palette.grey[800]}
                    fullWidth
                    onClick={() => handleDelete()}
                    disabled={deleteLoading}
                  >
                    Delete Availability
                  </Button>
                </Box>
              </Paper>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              {/* Shift Count */}
              <Typography className={classes.sectionHeading}>
                How many shifts are you looking to work per week?
              </Typography>
              <Typography className={classes.sectionSubtext}>
                Select the number of shifts you're aiming for.
              </Typography>
              <FormControl variant="outlined" fullWidth>
                <Select value={data?.no_of_shift || ""} name="no_of_shift" onChange={handleChange}>
                  <MenuItem value="">Select a shift</MenuItem>
                  {[1, 2, 3, 4, 5, 6, 7].map((val) => (
                    <MenuItem value={val} key={val}>
                      {val} shift{val > 1 ? "s" : ""}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              {/* Travel for Work */}
              <Typography className={classes.sectionHeading}>Would you travel for work?</Typography>
              <RadioGroup name="is_travel" value={data?.is_travel} onChange={handleChange} className={classes.radioGroup}>
                <FormControlLabel value={1} control={<Radio color="primary" />} label="Yes" />
                <FormControlLabel value={0} control={<Radio color="primary" />} label="No" />
              </RadioGroup>
            </Grid>
          </Grid>

          <Box display="flex" justifyContent="flex-end">
            <Button variant="contained" color="primary" type="submit">Update Preferences</Button>
          </Box>
        </form>
      </div>
    </>
  );
};

export default Preferences;
